var indexOf = [].indexOf;

import featureNames from 'constants/feature_names';

angular.module('gym.invoices').factory('InvoiceRescheduleService', ["$rootScope", "$modal", "$q", "$filter", "flash", "BulkInvoices", function($rootScope, $modal, $q, $filter, flash, BulkInvoices) {
  return {
    validate: function(invoice, featureNames) {
      var deferred, newDueDate;
      deferred = $q.defer();
      newDueDate = $filter('stringToDate')(invoice.rescheduled_due_date);
      featureNames = featureNames;
      invoice.rootObjectName = 'invoice';
      invoice.doPUT(invoice, 'validate_reschedule').then(function(response) {
        var modalInstance, ref, ref1, ref2, requireConfirm;
        requireConfirm = ((ref = response.upcoming_payment_clashes) != null ? ref.length : void 0) || ((ref1 = response.enrolled_in_due_payment_sequences) != null ? ref1.length : void 0) || ((ref2 = response.enrolled_in_payment_failure_sequences) != null ? ref2.length : void 0);
        if (requireConfirm) {
          modalInstance = $modal.open({
            template: require('templates/gyms/invoices/confirm_reschedule_modal.html.slim'),
            size: 'lg',
            resolve: {
              invoice: function() {
                return invoice;
              },
              newDueDate: function() {
                return newDueDate;
              },
              validateResponse: function() {
                return response;
              },
              featureNames: function() {
                return featureNames;
              }
            },
            controller: ["$scope", "$modalInstance", "invoice", "newDueDate", "validateResponse", "featureNames", function($scope, $modalInstance, invoice, newDueDate, validateResponse, featureNames) {
              $scope.currency_symbol = $rootScope.gym.currency_symbol;
              $scope.invoice = invoice;
              $scope.newDueDate = newDueDate;
              $scope.validateResponse = validateResponse;
              $scope.featureNames = featureNames;
              $scope.submit = function() {
                return $modalInstance.close();
              };
              return $scope.cancel = function() {
                return $modalInstance.dismiss('cancel');
              };
            }]
          });
          return modalInstance.result.then(function() {
            return deferred.resolve();
          }, function() {
            invoice.rescheduled_due_date = invoice.due_date;
            return deferred.reject();
          });
        } else {
          return deferred.resolve();
        }
      }, function(error) {
        var modalInstance;
        deferred.reject();
        invoice.rescheduled_due_date = invoice.due_date;
        return modalInstance = $modal.open({
          template: require('templates/gyms/invoices/reschedule_error_modal.html.slim'),
          size: 'lg',
          resolve: {
            invoice: function() {
              return invoice;
            },
            newDueDate: function() {
              return newDueDate;
            },
            error: function() {
              return error.data;
            }
          },
          controller: ["$scope", "$stateParams", "$modalInstance", "invoice", "newDueDate", "error", function($scope, $stateParams, $modalInstance, invoice, newDueDate, error) {
            $scope.error = error;
            if (error.rescheduled_before_membership_starts) {
              $scope.minValidDate = _.values(error.rescheduled_before_membership_starts[0])[0];
            }
            if (error.rescheduled_before_today) {
              $scope.minValidDate = _.values(error.rescheduled_before_today[0])[0];
            }
            if (error.rescheduled_after_membership_ends) {
              $scope.maxValidDate = _.values(error.rescheduled_after_membership_ends[0])[0];
            }
            $scope.currency_symbol = $rootScope.gym.currency_symbol;
            $scope.invoice = invoice;
            $scope.newDueDate = newDueDate;
            $scope.isContactPage = function() {
              var ref;
              return !!((ref = $stateParams.contactId) != null ? ref.length : void 0);
            };
            $scope.getErrorType = function() {
              switch (false) {
                case !error.rescheduled_into_suspension_period:
                  return 'rescheduled_into_suspension_period';
                case !error.rescheduled_before_membership_starts:
                  return 'rescheduled_before_membership_starts';
                case !error.rescheduled_before_today:
                  return 'rescheduled_before_today';
                case !error.rescheduled_after_membership_ends:
                  return 'rescheduled_after_membership_ends';
                default:
                  return 'invoice_already_exists';
              }
            };
            return $scope.close = function() {
              return $modalInstance.dismiss('cancel');
            };
          }]
        });
      });
      return deferred.promise;
    },
    reschedule: function(invoice, reloadTable, featureNames) {
      return this.validate(invoice, featureNames).then(function() {
        return invoice.doPUT({
          rescheduled_due_date: invoice.rescheduled_due_date
        }).then(function() {
          flash.success = 'The due date was changed successfully';
          return reloadTable();
        }, function(error) {
          if (error.data.error_message) {
            flash.error = error.data.error_message;
          } else {
            flash.error = "There was an error processing the request.";
          }
          return invoice.rescheduled_due_date = invoice.due_date;
        });
      });
    },
    bulkReschedule: function(selectedInvoices, rescheduleDate, dateLabel, reloadTable, featureNames) {
      var params;
      params = {
        ids: _.map(selectedInvoices, function(invoice) {
          return invoice.id;
        }),
        invoices: {
          rescheduled_due_date: rescheduleDate
        },
        withoutNamespace: true
      };
      return BulkInvoices.doPUT(params, 'validate_reschedule_bulk').then(function(response) {
        var modalInstance, ref, ref1, ref2, requireConfirm;
        requireConfirm = ((ref = response.upcoming_payment_clashes) != null ? ref.length : void 0) || ((ref1 = response.enrolled_in_due_payment_sequences) != null ? ref1.length : void 0) || ((ref2 = response.enrolled_in_payment_failure_sequences) != null ? ref2.length : void 0);
        if (requireConfirm) {
          modalInstance = $modal.open({
            template: require('templates/gyms/invoices/confirm_bulk_reschedule_modal.html.slim'),
            size: 'lg',
            resolve: {
              invoices: function() {
                return _.filter(selectedInvoices, function(invoice) {
                  var ref3;
                  return response.upcoming_payment_clashes && (ref3 = +invoice.invoice_id, indexOf.call(response.upcoming_payment_clashes.map(function(item) {
                    return +item;
                  }), ref3) >= 0);
                });
              },
              newDueDate: function() {
                return dateLabel;
              },
              validateResponse: function() {
                return response;
              },
              featureNames: function() {
                return featureNames;
              }
            },
            controller: ["$scope", "$modalInstance", "invoices", "newDueDate", "validateResponse", "featureNames", function($scope, $modalInstance, invoices, newDueDate, validateResponse, featureNames) {
              $scope.currency_symbol = $rootScope.gym.currency_symbol;
              $scope.invoices = invoices;
              $scope.newDueDate = newDueDate;
              $scope.validateResponse = validateResponse;
              $scope.featureNames = featureNames;
              $scope.submit = function() {
                return $modalInstance.close();
              };
              return $scope.cancel = function() {
                return $modalInstance.dismiss('cancel');
              };
            }]
          });
          return modalInstance.result.then(function() {
            return BulkInvoices.doPUT(params).then(function() {
              flash.success = 'The due date was changed successfully';
              return reloadTable();
            }, function() {
              return flash.error = 'There was an error processing the request.';
            });
          });
        } else {
          return BulkInvoices.doPUT(params).then(function() {
            flash.success = 'The due date was changed successfully';
            return reloadTable();
          }, function() {
            return flash.error = 'There was an error processing the request.';
          });
        }
      }, function(response) {
        var modalInstance;
        return modalInstance = $modal.open({
          template: require('templates/gyms/invoices/bulk_reschedule_error_modal.html.slim'),
          size: 'lg',
          resolve: {
            invoices: function() {
              var findInvoice;
              findInvoice = function(collection, invoice) {
                return _.find(response.data[collection], function(item) {
                  return +invoice.invoice_id === +_.keys(item)[0];
                });
              };
              return _.filter(selectedInvoices, function(invoice) {
                var ref;
                switch (false) {
                  case !response.data.rescheduled_into_suspension_period:
                    return findInvoice('rescheduled_into_suspension_period', invoice);
                  case !response.data.rescheduled_before_membership_starts:
                    return findInvoice('rescheduled_before_membership_starts', invoice);
                  case !response.data.rescheduled_before_today:
                    return findInvoice('rescheduled_before_today', invoice);
                  case !response.data.rescheduled_after_membership_ends:
                    return findInvoice('rescheduled_after_membership_ends', invoice);
                  default:
                    return ref = +invoice.invoice_id, indexOf.call(response.data.processed_payment_clashes.map(function(item) {
                      return +item;
                    }), ref) >= 0;
                }
              });
            },
            newDueDate: function() {
              return dateLabel;
            },
            error: function() {
              return response.data;
            }
          },
          controller: ["$scope", "$modalInstance", "$stateParams", "invoices", "newDueDate", "error", function($scope, $modalInstance, $stateParams, invoices, newDueDate, error) {
            $scope.invoices = invoices;
            $scope.error = error;
            $scope.newDueDate = newDueDate;
            $scope.getMinValidDate = function(invoice) {
              var dates, match;
              dates = error.rescheduled_before_membership_starts || error.rescheduled_before_today;
              match = _.find(dates, function(item) {
                return +invoice.invoice_id === +_.keys(item)[0];
              });
              return _.values(match)[0];
            };
            $scope.getMaxValidDate = function(invoice) {
              var match;
              match = _.find(error.rescheduled_after_membership_ends, function(item) {
                return +invoice.invoice_id === +_.keys(item)[0];
              });
              return _.values(match)[0];
            };
            $scope.isContactPage = function() {
              var ref;
              return !!((ref = $stateParams.contactId) != null ? ref.length : void 0);
            };
            $scope.getErrorType = function() {
              switch (false) {
                case !error.rescheduled_into_suspension_period:
                  return 'rescheduled_into_suspension_period';
                case !error.rescheduled_before_membership_starts:
                  return 'rescheduled_before_membership_starts';
                case !error.rescheduled_before_today:
                  return 'rescheduled_before_today';
                case !error.rescheduled_after_membership_ends:
                  return 'rescheduled_after_membership_ends';
                default:
                  return 'invoice_already_exists';
              }
            };
            return $scope.cancel = function() {
              return $modalInstance.dismiss('cancel');
            };
          }]
        });
      });
    },
    blockFutureRetries: function(invoice) {
      return invoice.customPUT('', "block_future_retries");
    },
    unblockFutureRetries: function(invoice) {
      return invoice.customPUT('', "remove_retry_block");
    },
    blockReceiptDelivery: function(invoice) {
      return invoice.customPUT('', 'block_receipt_delivery');
    },
    unblockReceiptDelivery: function(invoice) {
      return invoice.customPUT('', 'remove_receipt_block');
    }
  };
}]);
